var map = {
	"./0ece5170-0044-4abf-8228-293c80b538e7.JPG": 8406,
	"./Ganga-Indian-Restaurant_FINAL-LOGO.png": 356,
	"./Subworks Logo PNG.png": 6461,
	"./f9770592-dddf-4a67-890b-3116b31241b3.webp": 4446
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8692;